<template>
  <div class="macchinepacchetti">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Pacchetti della macchina</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="success" style="float: right" to="/macchine/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi Nuova Macchina</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="stato" slot-scope="row">
              <font-awesome-icon v-if="row.item.stato == true" icon="check" />
              <font-awesome-icon v-if="row.item.stato == false" icon="sync" />
              <font-awesome-icon v-if="row.item.stato == null" icon="exclamation-triangle" />
            </template>

            <template slot="createdAt" slot-scope="row">
              {{dataFormat(row.item.createdAt)}}
            </template>

            <template slot="action" slot-scope="row">
                <b-button size="sm" variant="danger" v-on:click="openModalDeletePacchetto(row.item)" v-if="row.item.stato != false"><font-awesome-icon icon="trash-alt" /></b-button>
                <b-button size="sm" variant="success" style="margin-left: 10px;" v-on:click="downloadPacchetto(row.item)" v-if="row.item.stato == true"><font-awesome-icon icon="file-download" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Si vuole eliminare il seguente pacchetto?">
      <p>Sei sicuro di voler eliminare il seguente pacchetto:</p>
      <br>
      <strong>-> {{modalData.delete.nomefile}}</strong>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deletePacchetto(modalData.delete.id)">Elimina</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">Annulla</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'


export default {
  name: 'macchinepacchetti',
  data() {
    return {
      lista: [],

      sortBy: 'createdAt',
      sortDesc: true,

      campi: [
        {key: 'nomefile', label: 'Nome Pacchetto', sortable: true},
        {key: 'note', label: 'Note', sortable: true},
        {key: 'stato', label: 'Stato', sortable: true},
        {key: 'createdAt', label: 'Data Creazione', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,

      modal:{
        delete: false
      },
      modalData:{
        delete: {}
      }
    }
  },
  created: function(){
    this.loadListaPacchetti()

    setTimeout(this.loadListaPacchetti, 5000)
  },
  methods: {
    dataFormat(data){
      var data_ = new Date(data)

      return data_.getDate()+"/"+(data_.getMonth()+1)+"/"+data_.getFullYear()+
        " "+data_.getHours()+":"+data_.getMinutes()+":"+data_.getSeconds()
    },
    loadListaPacchetti(){
      Vue.http.post('macchina/pacchetti/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.lista = response.body.data

          this.totalRows = this.lista.length

          try{
            var x = this.lista.filter(e => {
              if(e.stato == false)
                return true
              return false
            })

            if(x.length > 0)
              setTimeout(this.loadListaPacchetti, 10000)
          }catch(e){
            console.log(e)
          }
        }else{        
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore!",
            type: 'error'
        })
      })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeletePacchetto(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    deletePacchetto(id){
      Vue.http.post('macchina/pacchetti/'+this.$route.params.id+"/delete/"+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadListaPacchetti()

          this.modalData.delete = {}
          this.modal.delete = false

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Pacchetto eliminato con successo!',
              type: 'success'
          })
        }else{        
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore!",
            type: 'error'
        })
      })
    },
    downloadPacchetto(item){
      window.open(Vue.prototype.$hostlink+"macchina/pacchetti/"+this.$route.params.id+"/download/"+item.id)
    }
  }
}
</script>

<style scoped>

</style>